import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface MessageBubbleProps {
  text: string
  isUser: boolean
  timestamp?: string
  patientProfilePicture?: string | null
}

const MessageBubble = ({ text, isUser, timestamp, patientProfilePicture }: MessageBubbleProps) => {
  const formatTime = (timestamp: string) => {
    try {
      return new Date(timestamp).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      })
    } catch (error) {
      return ''
    }
  }

  return (
    <div
      className={`
        mb-4 flex w-full items-start gap-3

        ${isUser ? 'justify-end pr-1' : `justify-start pl-1`}
      `}
    >
      {isUser && (
        <img
          src={patientProfilePicture || '/images/user.jpg'}
          alt='Patient profile'
          className='mt-1 h-10 w-10 shrink-0 rounded-full object-cover'
        />
      )}
      <div
        className={`
          flex flex-col

          ${isUser ? 'max-w-[85%] items-start' : 'max-w-[85%] items-start'}
        `}
      >
        <div
          className={`
            relative rounded-[20px] p-3 min-w-28 pb-6 pe-10

            ${
              isUser
                ? 'rounded-tr-sm  bg-white text-black border border-[#A7B2D0]'
                : `rounded-tl-sm bg-white text-black border border-[#E2B2D2]`
            }
            max-w-full

            whitespace-pre-wrap pe-6
          `}
        >
          {isUser ? (
            <span className='text-black'>{text}</span>
          ) : (
            <div className={`prose prose-sm max-w-none whitespace-pre-wrap`}>
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  p: ({ ...props }) => <p className='mb-2 last:mb-0 text-black' {...props} />,
                  ul: ({ ...props }) => <ul className='mb-2 pl-4 list-disc text-black' {...props} />,
                  ol: ({ ...props }) => <ol className='mb-2 pl-4 list-decimal text-black' {...props} />,
                  li: ({ ...props }) => <li className='mb-1 text-black' {...props} />,
                  h1: ({ ...props }) => <h1 className='text-lg font-bold mb-2 text-black' {...props} />,
                  h2: ({ ...props }) => <h2 className='text-base font-bold mb-2 text-black' {...props} />,
                  h3: ({ ...props }) => <h3 className='text-sm font-bold mb-2 text-black' {...props} />,
                  strong: ({ ...props }) => <strong className='font-bold text-black' {...props} />,
                  em: ({ ...props }) => <em className='italic text-black' {...props} />,
                  code: ({ ...props }) => (
                    <code className='bg-gray-100 dark:bg-gray-800 rounded px-1 text-black dark:text-white' {...props} />
                  ),
                  pre: ({ ...props }) => (
                    <pre
                      className='bg-gray-100 dark:bg-gray-800 rounded p-2 mb-2 overflow-x-auto text-black dark:text-white'
                      {...props}
                    />
                  ),
                  blockquote: ({ ...props }) => (
                    <blockquote className='border-l-4 border-gray-200 pl-4 mb-2 text-black' {...props} />
                  ),
                  a: ({ ...props }) => <a className='text-blue-500 hover:underline break-all' {...props} />,
                }}
              >
                {text}
              </ReactMarkdown>
            </div>
          )}

          {timestamp && (
            <span
              className={`
              absolute bottom-2 right-3 text-xs

              ${isUser ? 'text-black' : 'text-black'}
            `}
            >
              {formatTime(timestamp)}
            </span>
          )}
          {/* <div
            className={`
              absolute top-0 h-4 w-4

              ${isUser ? 'right-[-8px]' : 'left-[-8px]'}
              ${isUser ? 'bg-[linear-gradient(90deg,#E1B2D2_0%,#BAE4F2_100%)]' : 'bg-white'}
            `}
            style={{
              clipPath: isUser ? 'polygon(0 0, 0 100%, 100% 0)' : 'polygon(100% 0, 0 0, 100% 100%)',
            }}
          /> */}
        </div>
      </div>
    </div>
  )
}

export default MessageBubble
